<script>
export default{
	props:{
		program:{required:true},
		active: Boolean
	},
	methods:{
		programItemHover(programId){
			eventsBuffer.$emit('displayInfowindow', {
				markerId:programId
			});
		}
	},
	
	mounted(){}
}
</script>

<template>
	<li class="member">
		<h4>{{ program.title }}</h4>
		<p class="address">
			{{ program.street_address}}<br>
			{{ `${program.city}, ${program.state} ${program.zip}`}} <br>
			{{ program.phone }}
		</p>
		<p class="website" v-if="program.website_url">
			<a :href="`http://${program.website_url}`" target="_blank">{{ program.website_url}}</a>
		</p>
		<button class="see-pin" @click="programItemHover(program.id)" :class="{active: active}">
			<i class="fa fa-map-marker-alt"/>
		</button>
	</li>
	
	<!--<ul>-->
		<!--<li v-if="!programs.length">No programs available.</li>-->
		<!--<template v-for="program in programs"></template>-->
	<!--</ul>-->
</template>


// WEBPACK FOOTER //
// resources/assets/js/views/pages/near-programs-results.vue